import { render, staticRenderFns } from "./JcomTableCreate.vue?vue&type=template&id=2ebac1b0"
import script from "./JcomTableCreate.vue?vue&type=script&lang=js"
export * from "./JcomTableCreate.vue?vue&type=script&lang=js"
import style0 from "./JcomTableCreate.vue?vue&type=style&index=0&id=2ebac1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports